import { Icon } from '@nimbus-ds/components';
import { CameraIcon } from '@nimbus-ds/icons';

function AICameraIcon() {
  return (
    <Icon color="ai-generative" source={<CameraIcon />} aria-hidden="true" />
  );
}

export default AICameraIcon;
